import styled from "@emotion/styled";
import { headerLinkMetadata, LinkMetadataItemProps } from "../header/Utils";
import { RouteID } from "../../routing/routes";
import { useState } from "react";
import { Link } from "react-router";
import {
  zIndex,
  spacing,
  fontSize,
  layout,
  letterSpacing,
  nav,
  text,
} from "@atlas-int/tokens";
import { googleAnalyticsCustomEvent } from "../../sharedUtilities/analytics";

const HamburgerMenuList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: ${layout.navBarExpandedWidth};
  color: ${text.primary};
  position: absolute;
  top: 0px;
  list-style-type: none;
  margin: 0px;
  padding: 0px;
  z-index: ${zIndex.navigation};
  background-color: ${nav.background};
`;

const HamburgerMenuListItem = styled.li`
  width: 100%;
  color: ${text.onDark};

  align-items: center;
  cursor: default;
  position: relative;
  background-color: transparent;
  color: ${text.onDark};

  & a,
  span {
    display: flex;
    padding: ${spacing[2]} ${spacing[10]};
    text-transform: uppercase;
    letter-spacing: ${letterSpacing.caps};
    font-size: ${fontSize["2xl"]};
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }

  // & {
  //     :hover, .highlight {
  //         background-color: none;
  //         color: white;
  //     }
  // }
`;

const InnerUl = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${spacing[8]};
  list-style-type: none;
`;

const InnerLi = styled.li`
  text-align: left;
  color: ${text.onDark};

  & a {
    text-transform: none;
    letter-spacing: ${letterSpacing.none};
  }
`;

interface ExpandableMenuItemInterface {
  route: string;
  routeId: RouteID;
  label: string;
  subMenuItems: LinkMetadataItemProps[] | undefined;
  isOpen: boolean;
  setIsOpen: any;
  closeMenu: () => void;
}

const ExpandableMenuItem = ({
  route,
  label,
  subMenuItems,
  isOpen,
  setIsOpen,
  closeMenu,
}: ExpandableMenuItemInterface) => {
  let highlightClassName: string | null = null;

  let submenuContents: React.ReactElement | null = null;
  if (isOpen && subMenuItems) {
    highlightClassName = "highlight";

    submenuContents = (
      <InnerUl>
        {subMenuItems.map(({ route, label }, index) => (
          <InnerLi key={index}>
            <Link to={route} onClick={closeMenu}>{label}</Link>
          </InnerLi>
        ))}
      </InnerUl>
    );
  } else {
    highlightClassName = null;
    submenuContents = null;
  }

  let primaryMenuItemLink;
  if (subMenuItems) {
    primaryMenuItemLink = (
      <span>
        {label} {subMenuItems ? "+" : ""}
      </span>
    );
  } else {
    primaryMenuItemLink = <Link to={route} onClick={closeMenu}>{label}</Link>;
  }

  return (
    <>
      <HamburgerMenuListItem
        className={highlightClassName ? highlightClassName : ""}
        onClick={() => {
          if (isOpen) {
            setIsOpen(null);
          } else {
            setIsOpen(label);
            googleAnalyticsCustomEvent("menu", "open", "sidebar", "explore");
          }
        }}
      >
        {primaryMenuItemLink}
        {submenuContents}
      </HamburgerMenuListItem>
    </>
  );
};

const HamburgerMenu = ({ closeMenu }: { closeMenu: any }) => {
  const [isOpen, setIsOpen] = useState(null);
  return (
    <HamburgerMenuList>
      {headerLinkMetadata.map((navigationLink) => {
        return (
          <ExpandableMenuItem
            isOpen={isOpen === navigationLink.label}
            setIsOpen={setIsOpen}
            routeId={navigationLink.routeId}
            route={navigationLink.route}
            label={navigationLink.label}
            subMenuItems={navigationLink.children}
            closeMenu={closeMenu}
          />
        );
      })}
    </HamburgerMenuList>
  );
};

export default HamburgerMenu;
